import { useState } from 'react'
import Modal from '../ui/Modal'
import { useChat } from '../../providers/chat/context'

type Props = { messageId: string; note: string; onClose: () => void }

export default function FeedbackDialog({ messageId, note, onClose }: Props) {
  const { setFeedback } = useChat()
  const [text, setText] = useState(note)
  const [saving, setSaving] = useState(false)

  async function save(value: string | null) {
    setSaving(true)
    try {
      await setFeedback(messageId, value)
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal title="Feedback on this reply" width="max-w-md" onClose={onClose}>
      <textarea
        autoFocus
        rows={5}
        value={text}
        onChange={(event) => setText(event.target.value)}
        placeholder="What was wrong, or what should it have said?"
        className="w-full resize-none rounded-lg border border-stone-300 px-3 py-2 text-sm text-stone-900 focus:border-purple-400 focus:ring-2 focus:ring-purple-100 focus:outline-none"
      />

      <div className="mt-4 flex justify-end gap-2">
        {note && (
          <button
            type="button"
            disabled={saving}
            onClick={() => void save(null)}
            className="mr-auto inline-flex h-9 items-center rounded-xl px-3 text-sm font-medium text-red-600 transition-colors enabled:hover:bg-red-50 disabled:opacity-60"
          >
            Remove
          </button>
        )}
        <button
          type="button"
          onClick={onClose}
          className="inline-flex h-9 items-center rounded-xl border border-stone-300 bg-white px-3 text-sm font-medium text-stone-900 transition-colors hover:bg-stone-50"
        >
          Cancel
        </button>
        <button
          type="button"
          disabled={saving || !text.trim()}
          onClick={() => void save(text.trim())}
          className="inline-flex h-9 items-center rounded-xl bg-linear-to-b from-stone-700 to-stone-950 px-3 text-sm font-medium text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.12),0_1px_2px_rgba(28,25,23,0.2)] transition-opacity enabled:hover:opacity-90 disabled:opacity-60"
        >
          Save
        </button>
      </div>
    </Modal>
  )
}
